import { motion } from 'framer-motion';
import { ArrowUpRight, Handshake } from 'lucide-react';

const PARTNERS = [
  {
    name: 'Daiya',
    logo: 'https://customer-assets.emergentagent.com/job_vegan-danish-bakery/artifacts/n0l62wu7_Daiya-Logo-DairyFree-Colour-800x350.png',
    role: 'Plant-based cheese & dairy alternatives',
    blurb: "Daiya supplies the cultured plant-based cream cheese and shreds that finish our Happy Eats bagels, breakfast sandwiches, mac & cheese and lasagna.",
    url: 'https://daiyafoods.com/'
  },
  {
    name: 'Yoso',
    logo: 'https://customer-assets.emergentagent.com/job_vegan-danish-bakery/artifacts/uft29he6_YOSO-Logo-BlackGreen_3b920c98-21df-4299-8b9b-686403a3eb94.webp',
    role: 'Organic plant-based dairy alternatives',
    blurb: "Yoso brings small-batch, organic soy and coconut-based cultured products into our Canadian recipes \u2014 a long-time partner from the Toronto plant-based scene.",
    url: 'https://yoso.ca/'
  },
  {
    name: 'TMRW',
    logo: 'https://customer-assets.emergentagent.com/job_vegan-danish-bakery/artifacts/504dbzo2_TMRW-grey.png',
    role: 'Plant-based meats',
    blurb: "TMRW crafts the plant-based meats behind our savoury builds — the ham, bacon and sausage that make our breakfast sandwiches, melts and comfort meals satisfying.",
    url: 'https://tmrwfoods.com/'
  }
];

export const EventsPartners = () => (
  <section className="py-16 md:py-24 bg-parchment/40">
    <div className="container mx-auto">
      <div className="max-w-2xl">
        <div className="font-script text-2xl text-leaf">our partners</div>
        <h2 className="font-display text-4xl sm:text-5xl text-primary font-medium leading-tight mt-1">
          In good company,<br/><span className="italic font-light text-leaf">on every tray.</span>
        </h2>
        <p className="mt-4 text-muted-foreground text-base md:text-lg">
          The brands behind the brand. We collaborate with Canada's most-loved plant-based
          ingredient makers to deliver the texture, melt and flavor our customers expect.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
        {PARTNERS.map((p, i) => (
          <motion.a
            key={p.name}
            href={p.url}
            target="_blank"
            rel="noopener noreferrer"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.08 }}
            className="group relative flex flex-col rounded-3xl bg-card border border-border/70 overflow-hidden shadow-soft hover:shadow-pop hover:-translate-y-1 transition-all duration-500"
          >
            <div className="relative h-56 sm:h-64 bg-secondary/60 grid place-items-center p-10 overflow-hidden">
              <div className="absolute inset-0 bg-grain opacity-40 pointer-events-none" />
              <img
                src={p.logo}
                alt={`${p.name} logo`}
                className="relative max-h-28 max-w-[70%] object-contain group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute top-4 left-4 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-background/85 backdrop-blur text-[10px] uppercase tracking-[0.18em] text-primary font-medium">
                <Handshake className="h-3 w-3 text-leaf" /> Partner 0{i + 1}
              </div>
              <div className="absolute top-4 right-4 h-9 w-9 rounded-full bg-background/85 backdrop-blur grid place-items-center text-primary group-hover:bg-accent group-hover:text-accent-foreground transition-colors">
                <ArrowUpRight className="h-4 w-4" />
              </div>
            </div>
            <div className="p-7 flex flex-col flex-1">
              <h3 className="font-display text-2xl font-semibold text-primary">{p.name}</h3>
              <div className="text-xs uppercase tracking-[0.16em] text-leaf font-medium mt-1.5">{p.role}</div>
              <p className="text-sm text-muted-foreground leading-relaxed mt-4">{p.blurb}</p>
              <div className="mt-auto pt-5 text-sm font-medium text-primary group-hover:text-leaf transition-colors inline-flex items-center gap-1.5">
                Visit {p.url.replace(/^https?:\/\//, '').replace(/\/$/, '')} <ArrowUpRight className="h-4 w-4" />
              </div>
            </div>
          </motion.a>
        ))}
      </div>

      <div className="mt-10 text-center text-sm text-muted-foreground">
        Interested in partnering with VDBF? Email <a href="mailto:toronto@vegandanishbakery.com" className="text-leaf font-medium underline-offset-4 hover:underline">toronto@vegandanishbakery.com</a>.
      </div>
    </div>
  </section>
);

export default EventsPartners;
